import { Card } from "react-bootstrap";


export const TracesListHeader = () => {

    return (

        <Card.Header className="card-header justify-content-between">
            <Card.Title>Requests </Card.Title>
        </Card.Header>

    )
}
